/* eslint-disable */
import React, { useState, useEffect, useContext, useRef } from 'react';
import { Grid2, Chip, Typography, CircularProgress, Box } from '@mui/material';
import { withStyles } from '@mui/styles';
import { withTranslation } from 'react-i18next';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import moment from 'moment';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useFormContext } from 'react-hook-form';
import ErrorIcon from '@mui/icons-material/Error';
import SplitIcon from '@mui/icons-material/CallSplit';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import FlagIcon from '@mui/icons-material/Flag';
import PaidIcon from '@mui/icons-material/Paid';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import AttachFile from '@mui/icons-material/AttachFile';
import { COLORS } from '../../../utils/Application_Constants';
import {
    ExpenseStatusChipStyles,
    ExpenseStatusEnum,
    ExpenseVaultStatusEnum,
    ExpenseStatusValuesEnum,
} from './ExpenseStatus.enum';
import { PreCodedStatusEnum } from './PreCodedStatus.enum';
import { ExpenseBillTypeEnum } from './BillType.enum';
import { ExpenseSourceEnum } from './ExpenseSource.enum';
import FilterAltIcon from '../../../assets/icons/FilterAltIcon';
import Tooltip from '../../../components/GlobalComponents/ToolTipComponent';
import { FeatureFlag } from '../../../components/GlobalComponents/FeatureFlagComponent/FeatureFlag';
import {
    getExpenseImageById,
    patchExpenseCreditMemo,
    updateHighPriority,
} from '../../Services/ExpenseService';
import { dataURItoBlob } from '../../Services/Common';
import CreditCardCategoryEnum from './CreditCardCategory.enum';
import { ExpenseClassEnum } from './ExpenseClass.enum';
import { useFlags } from 'launchdarkly-react-client-sdk';
import CreditDeterminationDialog from '../../../Shared/Components/Dialog/CreditDeterminationDialog';
import { AdminAuthContext } from '../../../Admin/Contexts/AdminAuthContext';
import usePayrollDayApprovalWarning from '../../hooks/usePayrollDayApprovalWarning';
import InvoicePriorityIndicator from './InvoicePriorityIndicator';

const styles = (theme) => ({
    scrollableHeaders: {
        overflowX: 'auto',
        borderRadius: '8px',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        '&::-webkit-scrollbar': {
            display: 'none',
        },
    },
    paragraph3: {
        display: 'flex',
        alignItems: 'center',
        color: COLORS.LT_MIDNIGHT100,
        fontSize: '14px',
        lineHeight: '18px',
        '& span:hover': {
            cursor: 'pointer',
        },
        whiteSpace: 'nowrap',
    },
    sortIcon: {
        transition: '.15s',
        '&.desc': {
            transform: 'rotate(180deg)',
        },
    },
    sortIcons: {
        '& $sortIcon': {
            margin: '-5px 0',
        },
    },
    headerRow: {
        display: 'flex',
        width: 'auto',
        backgroundColor: COLORS.LT_MIDNIGHTBG1,
    },
    tableRow: {
        '&:first-child': {
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
        },
        '&:last-child': {
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8,
        },
        '&:not(:last-child)': {
            borderBottom: `1px solid ${COLORS.LT_MIDNIGHT5}`,
        },
        '&:hover': {
            cursor: 'pointer',
            background: COLORS.LT_MIDNIGHTBG1,
        },
    },
    chipRoot: {
        justifyContent: 'start',
        fontWeight: 600,
        width: '170',
        minWidth: '170',
        maxWidth: '170',
        borderRadius: '22px',
        borderWidth: '0px',
        [theme.breakpoints.up('lg')]: {
            minWidth: '170px',
        },
    },
    ...ExpenseStatusChipStyles,
    tableCellicn: {
        width: 100,
        minWidth: 100,
        maxWidth: 100,
        '& .MuiTypography-body2': {
            maxWidth: '100%',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            textWrap: 'nowrap',
            lineHeight: '24px',
        },
    },
    tableCellxsm: {
        width: 110,
        minWidth: 110,
        '& .MuiTypography-body2': {
            maxWidth: '100%',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            textWrap: 'nowrap',
            lineHeight: '24px',
        },
    },
    tableCellsml: {
        width: 140,
        minWidth: 140,
        '& .MuiTypography-body2': {
            maxWidth: '100%',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            textWrap: 'nowrap',
            lineHeight: '24px',
        },
    },
    tableCellmed: {
        width: 180,
        minWidth: 180,
        '& .MuiTypography-body2': {
            maxWidth: '100%',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            textWrap: 'nowrap',
            lineHeight: '24px',
        },
    },
    tableCellmedlrg: {
        width: 200,
        minWidth: 200,
        '& .MuiTypography-body2': {
            maxWidth: '100%',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            textWrap: 'nowrap',
            lineHeight: '24px',
        },
    },
    tableCelllrg: {
        width: 260,
        minWidth: 260,
        '& .MuiTypography-body2': {
            maxWidth: '100%',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            textWrap: 'nowrap',
            lineHeight: '24px',
        },
    },
    tableBody: {
        position: 'relative',
        marginTop: '2em',
        borderBottom: `1px solid ${COLORS.LT_MIDNIGHT5}`,
    },
    tableCellContent: {
        padding: 10,
        alignItems: 'left',
    },
    tableCellContentWithIcons: {
        padding: 10,
        justifyContent: 'space-between',
    },
    tableCellContentRightJust: {
        padding: 10,
        alignItems: 'right',
        justifyContent: 'right',
    },
    headerCellicn: {
        width: 100,
        minWidth: 100,
        padding: '8px 8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'left',
        backgroundColor: COLORS.LT_MIDNIGHTBG1,
    },
    headerCellxsm: {
        width: 110,
        minWidth: 110,
        padding: '8px 8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'left',
        backgroundColor: COLORS.LT_MIDNIGHTBG1,
    },
    headerCellxsmrj: {
        width: 110,
        minWidth: 110,
        padding: '8px 8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'right',
        backgroundColor: COLORS.LT_MIDNIGHTBG1,
    },
    headerCellsml: {
        width: 140,
        minWidth: 140,
        padding: '8px 8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'left',
        backgroundColor: COLORS.LT_MIDNIGHTBG1,
    },
    headerCellsmlrj: {
        width: 140,
        minWidth: 140,
        padding: '8px 8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'right',
        backgroundColor: COLORS.LT_MIDNIGHTBG1,
    },
    headerCellmed: {
        width: 180,
        minWidth: 180,
        padding: '8px 8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'left',
        backgroundColor: COLORS.LT_MIDNIGHTBG1,
    },
    headerCellmedrj: {
        width: 180,
        minWidth: 180,
        padding: '8px 8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'right',
        backgroundColor: COLORS.LT_MIDNIGHTBG1,
    },
    headerCellmedlrg: {
        width: 200,
        minWidth: 200,
        padding: '8px 8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'left',
        backgroundColor: COLORS.LT_MIDNIGHTBG1,
    },
    headerCelllrg: {
        width: 260,
        minWidth: 260,
        padding: '8px 8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'left',
        backgroundColor: COLORS.LT_MIDNIGHTBG1,
    },
    loader: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 400,
    },
    statusCell: {
        width: 180,
        minWidth: 180,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    filterIcon: {
        color: COLORS.LT_JOURNEY,
    },
    expenseLink: {
        color: COLORS.LT_JOURNEY,
        textDecoration: 'none',
        fontSize: '14px',
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    flexCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
});

const nonClinicianReimbursementFeatureFlagColumnKeys = [
    'creditCardNumber',
    'periodEndDate',
    'postDate',
    'merchantName',
    'merchantAddress',
    'merchantCity',
    'merchantState',
    'travelerName',
    'ticketNumber',
    'source',
];
const nonClinicianReimbursementFeatureFlagColumnNames = [
    'Credit Card Account',
    'Period End',
    'Post Date',
    'Merchant Name',
    'Merchant Address',
    'Merchant City',
    'Merchant State',
    'Traveler Name',
    'Ticket Number',
    'Source',
];

const ExpenseTable = (props) => {
    const {
        classes,
        sortBy,
        sortDirection,
        config,
        expenses,
        isLoading,
        handleSort,
        t,
        pendingCCReview,
        creditCardReview,
        vendorPaymentReview,
        vaultChargesReview,
        onUpdateExpenses,
        onRefreshData,
        isReimbursement,
    } = props;

    const flags = useFlags();
    const {
        ltoeWebExpensesEnableCreditCardColumnsFeatures: isCreditCardColumnsEnabled,
        ltoeWebExpensesEnableClinicianReimbursementListViewChanges: enableNewCRListViewChanges,
    } = flags;

    const { isExpenseSystemAdministratorUser, isExpenseAdminUser } = useContext(AdminAuthContext);
    const isViewOnly = !(isExpenseSystemAdministratorUser || isExpenseAdminUser);
    const history = useHistory();
    const [openCreditAlertModal, setOpenCreditAlertModal] = useState(false);
    const [expenseSelected, setExpenseSelected] = useState(null);
    const [isCreatingCreditMemo, setIsCreatingCreditMemo] = useState(false);
    const [creditMemoError, setCreditMemoError] = useState(null);
    const { showPayrollWarningInCmm, payrollWarningMessage, gateApproval } =
        usePayrollDayApprovalWarning({ creditMemoDialogOpen: openCreditAlertModal });
    const tableContentRef = useRef(null);
    const scrollbarRef = useRef(null);
    const [scrollWidth, setScrollWidth] = useState('100%');

    useEffect(() => {
        const tableContent = tableContentRef.current;
        const scrollbar = scrollbarRef.current;

        if (!tableContent || !scrollbar) return;

        const handleTableScroll = () => {
            scrollbar.scrollLeft = tableContent.scrollLeft;
        };

        const handleScrollbarScroll = () => {
            tableContent.scrollLeft = scrollbar.scrollLeft;
        };

        const handleResize = () => {
            setScrollWidth(`${tableContent.scrollWidth}px`);
        };

        tableContent.addEventListener('scroll', handleTableScroll);
        scrollbar.addEventListener('scroll', handleScrollbarScroll);
        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            tableContent.removeEventListener('scroll', handleTableScroll);
            scrollbar.removeEventListener('scroll', handleScrollbarScroll);
            window.removeEventListener('resize', handleResize);
        };
    }, [expenses, isLoading]);

    const handleNavigation = (expense) => {
        if (vendorPaymentReview) {
            history.push(`/expenses/payment-request/${expense.id}`);
            return;
        }

        if (vaultChargesReview) {
            history.push(`/expenses/vault/${expense.id}`);
            return;
        }

        if (creditCardReview) {
            history.push(`/expenses/credit-card/${expense.id}`);
            return;
        }

        if (expense.source != null) {
            history.push(`/expense-redirect/${expense.id}`);
        } else if (pendingCCReview) {
            history.push(`/expenses/pending-cc/${expense.id}`);
        }
    };

    const { watch, getValues } = useFormContext();
    const formValues = watch(getValues());

    const handleClickExpense = (expense) => {
        if (
            expense?.status === ExpenseStatusValuesEnum.InvoiceReview &&
            expense?.previousVersionId
        ) {
            setOpenCreditAlertModal(true);
            setExpenseSelected(expense);
        } else {
            handleNavigation(expense);
        }
    };

    const handleClickOpenInNewTab = (expense, e, getExpenseUrl) => {
        e.stopPropagation();
        const url = getExpenseUrl(expense, pendingCCReview, vendorPaymentReview);
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    const handleClickExpenseLink = (expense, e, getExpenseUrl) => {
        e.preventDefault();
        e.stopPropagation();
        const url = getExpenseUrl(expense, pendingCCReview, vendorPaymentReview);
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    const handleConfirmCreditModal = async (creditType) => {
        const saveCreditMemo = async () => {
            try {
                setIsCreatingCreditMemo(true);
                setCreditMemoError(null);
                await patchExpenseCreditMemo(
                    expenseSelected.id,
                    creditType === 'full' ? 'Full' : 'Partial'
                );

                // Refresh the list view
                if (onRefreshData) {
                    onRefreshData();
                }

                setOpenCreditAlertModal(false);
            } catch (error) {
                console.error('Failed to update expense credit memo', error);
                setCreditMemoError('Failed to update expense credit memo');
            } finally {
                setIsCreatingCreditMemo(false);
            }
        };

        gateApproval({
            expenses: [expenseSelected],
            originalExpenses: [expenseSelected],
            isCreditMemoFlow: true,
            proceed: saveCreditMemo,
        });
    };

    useEffect(() => {
        if (!openCreditAlertModal) setCreditMemoError(null); // clear error when modal is closed
    }, [openCreditAlertModal]);

    // Dynamic status enum selection
    const getStatusEnum = (expense) => {
        if (vaultChargesReview || expense?.expenseClass === ExpenseClassEnum.Vault) {
            if (expense?.status === ExpenseStatusValuesEnum.Abandoned) {
                return ExpenseStatusEnum;
            }
            return ExpenseVaultStatusEnum;
        }

        const isExpenseNonPreCoded =
            expense?.expenseClass === ExpenseClassEnum.CreditCard ||
            expense?.expenseClass === ExpenseClassEnum.IngestedCCTransaction ||
            expense?.expenseClass === ExpenseClassEnum.Reimbursement ||
            expense?.expenseClass === ExpenseClassEnum.Payment ||
            pendingCCReview || // Credit Cards
            creditCardReview || // Credit Cards
            expense?.source !== null; // Payment expenses

        // It's pre-coded if it's not one of the above
        return isExpenseNonPreCoded ? ExpenseStatusEnum : PreCodedStatusEnum;
    };

    const [isHovered, setIsHovered] = useState(false);
    const renderStatusChip = (expense, index) => {
        const statusEnum = getStatusEnum(expense);

        const statusKey = Object.keys(statusEnum).find(
            (key) => statusEnum[key].value === expense.status
        );

        let statusTitle = 'Unknown';
        let status = 'Unknown';

        if (statusKey && statusEnum[statusKey]) {
            statusTitle = statusEnum[statusKey].UI ? statusEnum[statusKey].UI : 'Unknown';
            status = statusEnum[statusKey].value ? statusEnum[statusKey].value : 'Unknown';
        }

        return (
            <Grid2
                item
                className={`${classes.statusCell}`}
                style={{
                    backgroundColor: isHovered === expense ? COLORS.LT_MIDNIGHTBG1 : COLORS.WHITE,
                }}
                size={{ xs: 2 }}
                key={`${expense}-status-${index}`}
            >
                <Chip
                    label={statusTitle}
                    className={classes[`chip${status}`]}
                    classes={{ root: classes.chipRoot }}
                    title={statusTitle}
                />
            </Grid2>
        );
    };

    const renderSortableArrow = () => (
        <Grid2 container direction="column" className={classes.sortIcons}>
            <ArrowDropUpIcon className={`${classes.sortIcon} asc`} fontSize="small" />
            <ArrowDropUpIcon className={`${classes.sortIcon} desc`} fontSize="small" />
        </Grid2>
    );

    const handleMouseEnter = (index) => {
        setIsHovered(index);
    };

    const handleMouseLeave = () => {
        setIsHovered(null);
    };
    const checkIfFilterApplied = (status, columnKey) => {
        const plural = `${status}s`;
        const esplural = `${status}es`;
        const formValuesKeys = Object.keys(formValues);
        for (let index = 0; index < formValuesKeys.length; index++) {
            const key = formValuesKeys[index];
            if (
                (Object.prototype.hasOwnProperty.call(formValues, key) && key === plural) ||
                key === esplural
            ) {
                const value = formValues[key];
                if (value !== null && !(Array.isArray(value) && value.length === 0) && !!value) {
                    return true;
                }
            }
            if (key === 'Has Receipt' && (status === 'Receipt' || columnKey === 'hasAttachments')) {
                const value = formValues[key];
                if (value !== null && !(Array.isArray(value) && value.length === 0) && !!value) {
                    return true;
                }
            }
        }

        return false;
    };

    const handleFlagClick = async (e, expense) => {
        e.stopPropagation();

        if (isViewOnly) {
            return;
        }

        const updatedHighPriority = !expense.highPriority;

        const updatedExpenses = expenses.map((exp) =>
            exp.id === expense.id ? { ...exp, highPriority: updatedHighPriority } : exp
        );

        if (onUpdateExpenses) {
            onUpdateExpenses(updatedExpenses);
        }

        try {
            await updateHighPriority(expense.id, updatedHighPriority);
        } catch (error) {
            const revertedExpenses = expenses.map((exp) =>
                exp.id === expense.id ? { ...exp, highPriority: !updatedHighPriority } : exp
            );
            if (onUpdateExpenses) {
                onUpdateExpenses(revertedExpenses);
            }
            console.error('Failed to update high priority status', error);
        }
    };

    const renderExpenseIcons = (hasError, note, isSplitParent, isSplitChild) => {
        const isNote = !!note;
        return (
            <div>
                {isNote && (
                    <Tooltip title={`Notes: ${note}`}>
                        <ChatBubbleIcon
                            fontSize="small"
                            style={{ marginLeft: 5, color: COLORS.LT_MIDNIGHT25 }}
                        />
                    </Tooltip>
                )}
                {!isNote && (
                    <Tooltip title="">
                        <ChatBubbleIcon
                            fontSize="small"
                            style={{ marginLeft: 5, color: 'transparent' }}
                        />
                    </Tooltip>
                )}
                {hasError && (
                    <Tooltip title="One or more needs review reasons applied to this transaction">
                        <ErrorIcon
                            fontSize="small"
                            style={{ marginLeft: 5, color: COLORS.LT_PEPPER }}
                        />
                    </Tooltip>
                )}
                {!hasError && (
                    <Tooltip title="">
                        <ErrorIcon
                            fontSize="small"
                            style={{ marginLeft: 5, color: 'transparent' }}
                        />
                    </Tooltip>
                )}
                {isSplitChild && (
                    <Tooltip title="This transaction includes one or more split. Click to see related transactions">
                        <SplitIcon
                            fontSize="small"
                            style={{ marginLeft: 5, color: COLORS.LT_MIDNIGHT25 }}
                        />
                    </Tooltip>
                )}
                {isSplitParent && (
                    <Tooltip title="This transaction includes one or more split. Click to see related transactions">
                        <SplitIcon
                            fontSize="small"
                            style={{ marginLeft: 5, color: COLORS.LT_MIDNIGHT75 }}
                        />
                    </Tooltip>
                )}
                {!isSplitParent && !isSplitChild && (
                    <Tooltip title="">
                        <SplitIcon
                            fontSize="small"
                            style={{ marginLeft: 5, color: 'transparent' }}
                        />
                    </Tooltip>
                )}
            </div>
        );
    };

    const renderExpenseListHeaderCell = (name, key, sorted, sortKey, size, classSize) => {
        const isAmount = key === 'amount';
        const isReimbursedAmount = key === 'reimbursedAmount';
        const isAllocatedAmount = key === 'allocatedAmount';
        const isHighPriority = key === 'highPriority';
        const isInvoicePriority = key === 'isInvoicePriority';
        const isAttachments = key === 'hasAttachments';
        const renderHeaderContent = () => {
            if (isHighPriority) {
                return (
                    <Tooltip title="High Priority">
                        <FlagIcon
                            fontSize="medium"
                            style={{ color: COLORS.LT_MIDNIGHT25, cursor: 'pointer' }}
                            onClick={() => handleSort(sortKey)}
                        />
                    </Tooltip>
                );
            }

            if (isInvoicePriority) {
                return (
                    <Tooltip title="Invoice Priority">
                        <PaidIcon
                            fontSize="medium"
                            style={{ color: COLORS.LT_MIDNIGHT25, cursor: 'pointer' }}
                            onClick={() => handleSort(sortKey)}
                        />
                    </Tooltip>
                );
            }

            if (isAttachments) {
                return (
                    <Tooltip title="Attachments">
                        <AttachFile
                            fontSize="medium"
                            style={{ color: COLORS.LT_MIDNIGHT25, cursor: 'pointer' }}
                            onClick={() => handleSort(sortKey)}
                        />
                    </Tooltip>
                );
            }

            if (sortKey) {
                return <span onClick={() => handleSort(sortKey)}>{name}</span>;
            }
            return name;
        };

        return (
            <Grid2
                item
                size={{ xs: size }}
                key={`${key}-${name}`}
                className={
                    isAmount || isReimbursedAmount || isAllocatedAmount
                        ? classes[`headerCell${classSize}rj`]
                        : classes[`headerCell${classSize}`]
                }
                style={
                    isHighPriority || isInvoicePriority || isAttachments
                        ? { display: 'flex', justifyContent: 'center', alignItems: 'center' }
                        : {}
                }
            >
                {checkIfFilterApplied(name, key) && (
                    <FilterAltIcon className={classes.filterIcon} />
                )}
                <div
                    className={classes.paragraph3}
                    style={{ fontWeight: sorted ? 700 : 'initial' }}
                >
                    {renderHeaderContent()}
                    {sorted && (
                        <ArrowDropUpIcon
                            className={`${classes.sortIcon} ${sortDirection}`}
                            fontSize="small"
                        />
                    )}
                    {!sorted && sortKey && renderSortableArrow()}
                </div>
            </Grid2>
        );
    };

    const renderExpenseListHeader = () => {
        let columns = config.tableColumns;

        if (enableNewCRListViewChanges) {
            columns = columns?.filter((col) => col.key !== 'creditCardNumber');
        }

        if (pendingCCReview) {
            columns = config.pendingCCTableColumns;
        }

        if (creditCardReview) {
            columns = config.creditCardTableColumns;
        }

        if (vendorPaymentReview) {
            columns = config.vendorPaymentTableColumns;
        }

        if (vaultChargesReview) {
            columns = config.vaultChargesTableColumns;
        }

        if (isReimbursement) {
            columns = columns?.filter((col) => col.key !== 'periodEndDate');
        }

        if (!enableNewCRListViewChanges) {
            columns = columns?.filter((col) => col.key !== 'notes');
        }

        return (
            <Grid2 container wrap="nowrap" className={classes.headerRow}>
                {columns.map(({ name, key, sortKey, size, classSize }, index) => {
                    const sorted = sortBy === sortKey;
                    if (
                        !creditCardReview &&
                        !isCreditCardColumnsEnabled &&
                        nonClinicianReimbursementFeatureFlagColumnNames.includes(name)
                    ) {
                        return null;
                    }

                    return renderExpenseListHeaderCell(
                        name,
                        key,
                        sorted,
                        sortKey,
                        size,
                        classSize,
                        index
                    );
                })}
            </Grid2>
        );
    };

    const renderExpenseListGridRowCell = (expense, key, size, name, classSize, index) => {
        const isHighPriority = key === 'highPriority';
        const isInvoicePriority = key === 'isInvoicePriority';
        const isIcons = key === 'icons';
        const isExpenseId = key === 'expenseId';
        const isStatus = key === 'status';
        const isName = key === 'clinicianName';
        const hasName = expense.clinicianFirstName && expense.clinicianLastName;
        const isSource = key === 'source';
        const isCreditCard = key === 'creditCardNumber';
        const isBillType = key === 'billType';
        const isAmount = key === 'amount';
        const isReimbursedAmount = key === 'reimbursedAmount';
        const isAllocatedAmount = key === 'allocatedAmount';
        const isVaultPdf = key === 'vaultPdfExpenseImageId';
        const isDivision = key === 'division';
        const isAttachments = key === 'hasAttachments';
        const showAbbreviation =
            expense.currency === 'CAD' || expense.currency === 'MXN' || expense.currency === 'COP';
        const isDate =
            key === 'transactionDate' ||
            key === 'endDate' ||
            key === 'postDate' ||
            key === 'periodEndDate' ||
            key === 'startDate' ||
            key === 'payDate' ||
            key === 'submittedDate' ||
            key === 'created';
        const { errorCount } = expense;
        let hasError = false;
        if (errorCount > 0) {
            hasError = true;
        }
        const isSplitChild = !!expense.primaryExpenseId;
        const formattedDate = isDate && moment(expense[key]).format('MM/DD/YYYY');
        const clinicianFullName = `${expense.clinicianFirstName} ${expense.clinicianLastName}`;
        const isTicketNumber = key === 'ticketNumber';
        let value;
        if (isIcons || isTicketNumber) {
            value = expense[key] || '';
        } else {
            value = expense[key] ? expense[key] : '-';
        }
        if (isExpenseId) {
            value = expense.id;

            switch (expense.source) {
                case 0:
                    value += 'A';
                    break;
                case 1:
                    value += 'C';
                    break;
                default:
                    break;
            }

            const getExpenseUrl = (e, pendingCC, vendorPayment) => {
                if (vendorPayment) {
                    return `${window.location.origin}/#/expenses/payment-request/${e.id}`;
                }
                if (vaultChargesReview) {
                    return `${window.location.origin}/#/expenses/vault/${e.id}`;
                }
                if (creditCardReview) {
                    return `${window.location.origin}/#/expenses/credit-card/${e.id}`;
                }
                if (e.source != null) {
                    return `${window.location.origin}/#/expense-redirect/${e.id}`;
                }
                if (pendingCC) {
                    return `${window.location.origin}/#/expenses/pending-cc/${e.id}`;
                }
                return window.location.href;
            };

            return (
                <Grid2
                    item
                    key={`${expense}-${key}-${index}`}
                    size={{ xs: size }}
                    className={classes[`tableCell${classSize}`]}
                    style={{
                        backgroundColor:
                            isHovered === expense ? COLORS.LT_MIDNIGHTBG1 : COLORS.WHITE,
                    }}
                >
                    <div
                        className={classes.tableCellContent}
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <a
                            href={getExpenseUrl(expense, pendingCCReview, vendorPaymentReview)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={classes.expenseLink}
                            onClick={(e) => handleClickExpenseLink(expense, e, getExpenseUrl)}
                        >
                            {value}
                        </a>

                        <OpenInNewIcon
                            style={{
                                color: COLORS.LT_JOURNEY,
                                marginLeft: 8,
                                fontSize: 18,
                                cursor: 'pointer',
                            }}
                            onClick={(e) => handleClickOpenInNewTab(expense, e, getExpenseUrl)}
                        />
                    </div>
                </Grid2>
            );
        }

        const tooltipNotes =
            expense.notes?.length > 100 ? `${expense.notes.substr(0, 100)}...` : expense.notes;
        if (isName && hasName) value = clinicianFullName;
        if (isDate && expense[key]) value = formattedDate;
        if (isStatus) return renderStatusChip(expense, index);
        if (
            isCreditCard &&
            expense.creditCardName &&
            expense.creditCardNumber &&
            expense.creditCardCategory
        )
            value = `${CreditCardCategoryEnum[expense.creditCardCategory]}-${
                expense.creditCardName
            }-${expense.creditCardNumber}`;

        if (isBillType && ExpenseBillTypeEnum[expense[key]])
            value = ExpenseBillTypeEnum[expense[key]];
        if (isSource && ExpenseSourceEnum[expense[key]]) value = ExpenseSourceEnum[expense[key]];
        if (isAmount && expense.currency) {
            value = !Number.isNaN(parseFloat(expense.amount))
                ? parseFloat(expense.amount).toFixed(2)
                : 0;
            value = `${showAbbreviation ? expense.currency : ''} ${t(
                `currency:${expense.currency}`
            )}${value}`;
        }
        if (isReimbursedAmount) {
            value = !Number.isNaN(parseFloat(expense.reimbursedAmount))
                ? parseFloat(expense.reimbursedAmount).toFixed(2)
                : value;
            value = !Number.isNaN(parseFloat(expense.reimbursedAmount))
                ? `${t(`currency:USD`)}${value}`
                : value;
        }
        if (isAllocatedAmount && expense.currency) {
            value = !Number.isNaN(parseFloat(expense.allocatedAmount))
                ? parseFloat(expense.allocatedAmount).toFixed(2)
                : 0;
            value = `${showAbbreviation ? expense.currency : ''} ${t(
                `currency:${expense.currency}`
            )}${value}`;
        }
        if (isDivision && value.includes('Emergency') && value.includes('Medicine')) {
            value = value.replace('Emergency', 'Hospital');
        }

        if (isHighPriority) {
            return (
                <Grid2
                    item
                    key={`${expense}-${key}-${index}`}
                    size={{ xs: size }}
                    className={classes[`tableCell${classSize}`]}
                    style={{
                        backgroundColor:
                            isHovered === expense ? COLORS.LT_MIDNIGHTBG1 : COLORS.WHITE,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Tooltip title="High Priority">
                        <FlagIcon
                            fontSize="medium"
                            style={{
                                color: expense.highPriority
                                    ? COLORS.LT_PEPPER
                                    : COLORS.LT_MIDNIGHT25,
                            }}
                            onClick={(e) => handleFlagClick(e, expense)}
                        />
                    </Tooltip>
                </Grid2>
            );
        }

        if (isInvoicePriority) {
            return (
                <Grid2
                    item
                    key={`${expense}-${key}-${index}`}
                    size={{ xs: size }}
                    className={classes[`tableCell${classSize}`]}
                    style={{
                        backgroundColor:
                            isHovered === expense ? COLORS.LT_MIDNIGHTBG1 : COLORS.WHITE,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <InvoicePriorityIndicator
                        isInvoicePriority={expense.isInvoicePriority}
                        timelineToInvoiceExpense={expense.timelineToInvoiceExpense}
                        fontSize="medium"
                    />
                </Grid2>
            );
        }

        if (isAttachments) {
            return (
                <Grid2
                    item
                    key={`${expense}-${key}-${index}`}
                    size={{ xs: size }}
                    className={classes[`tableCell${classSize}`]}
                    style={{
                        backgroundColor:
                            isHovered === expense ? COLORS.LT_MIDNIGHTBG1 : COLORS.WHITE,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    {expense.hasAttachments && (
                        <Tooltip title="Has Attachments">
                            <AttachFile
                                fontSize="medium"
                                style={{
                                    color: COLORS.LT_JOURNEY,
                                }}
                            />
                        </Tooltip>
                    )}
                </Grid2>
            );
        }

        if (isVaultPdf) {
            return (
                <Grid2
                    item
                    key={`${expense}-${key}-${index}`}
                    size={{ xs: size }}
                    className={[classes[`tableCell${classSize}`], classes.flexCenter]}
                >
                    {expense.vaultPdfExpenseImageId && (
                        <AttachFile
                            fontSize="medium"
                            style={{
                                color: COLORS.LT_JOURNEY,
                            }}
                            onClick={async (e) => {
                                e.stopPropagation();

                                const expenseImage = await getExpenseImageById(
                                    expense.id,
                                    expense.vaultPdfExpenseImageId,
                                    false
                                );

                                const blob = dataURItoBlob(expenseImage.image);
                                const blobUrl = URL.createObjectURL(blob);
                                window.open(blobUrl, '_blank');
                            }}
                        />
                    )}
                </Grid2>
            );
        }

        if (key === 'notes') {
            const note = expense.notes;
            return (
                <Grid2
                    item
                    key={`${expense}-${key}-${index}`}
                    size={{ xs: size }}
                    className={classes[`tableCell${classSize}`]}
                    style={{
                        backgroundColor:
                            isHovered === expense ? COLORS.LT_MIDNIGHTBG1 : COLORS.WHITE,
                    }}
                >
                    <div
                        className={classes.tableCellContent}
                        style={{ display: 'flex', alignItems: 'center' }}
                    >
                        {note ? (
                            <Tooltip title={note}>
                                <Typography variant="body2">{note}</Typography>
                            </Tooltip>
                        ) : (
                            <Typography variant="body2">-</Typography>
                        )}
                    </div>
                </Grid2>
            );
        }

        return (
            <Grid2
                item
                key={`${expense}-${key}-${index}`}
                size={{ xs: size }}
                className={classes[`tableCell${classSize}`]}
                style={{
                    backgroundColor: isHovered === expense ? COLORS.LT_MIDNIGHTBG1 : COLORS.WHITE,
                }}
            >
                <div
                    className={
                        isAmount || isReimbursedAmount || isAllocatedAmount
                            ? classes.tableCellContentRightJust
                            : classes.tableCellContent
                    }
                    style={{ display: 'flex', alignItems: 'center' }}
                >
                    {isIcons &&
                        renderExpenseIcons(hasError, tooltipNotes, expense.isParent, isSplitChild)}
                    <Typography variant="body2" title={value}>
                        {value}
                    </Typography>
                </div>
            </Grid2>
        );
    };

    const renderExpenseListGridRow = (expense) => {
        let columns = config.tableColumns;

        if (enableNewCRListViewChanges) {
            columns = columns?.filter((col) => col.key !== 'creditCardNumber');
        }

        if (pendingCCReview) {
            columns = config.pendingCCTableColumns;
        }

        if (creditCardReview) {
            columns = config.creditCardTableColumns;
        }

        if (vendorPaymentReview) {
            columns = config.vendorPaymentTableColumns;
        }

        if (vaultChargesReview) {
            columns = config.vaultChargesTableColumns;
        }

        if (isReimbursement) {
            columns = columns?.filter((col) => col.key !== 'periodEndDate');
        }

        if (!enableNewCRListViewChanges) {
            columns = columns?.filter((col) => col.key !== 'notes');
        }

        return (
            <Grid2
                container
                wrap="nowrap"
                className={classes.tableRow}
                onMouseEnter={() => handleMouseEnter(expense)}
                onMouseLeave={handleMouseLeave}
                onClick={() => handleClickExpense(expense)}
            >
                {columns.map(({ key, size, name, classSize }, index) => {
                    const shouldBeNonClinicianReimbursementFeatureFlagFiltered =
                        nonClinicianReimbursementFeatureFlagColumnKeys.includes(key);

                    if (
                        !creditCardReview &&
                        !isCreditCardColumnsEnabled &&
                        shouldBeNonClinicianReimbursementFeatureFlagFiltered
                    ) {
                        return null;
                    }

                    return renderExpenseListGridRowCell(expense, key, size, name, classSize, index);
                })}
            </Grid2>
        );
    };

    const renderExpenseListGrid = () => (
        <div className={classes.tableBody}>
            {expenses.map((expense, index) => (
                <React.Fragment key={`expense-${expense.id}-row-${index}`}>
                    {renderExpenseListGridRow(expense)}
                </React.Fragment>
            ))}
        </div>
    );

    return (
        <Box sx={{ position: 'relative', width: '100%' }}>
            <Grid2 container className={classes.scrollableHeaders} ref={tableContentRef}>
                {renderExpenseListHeader()}
                {isLoading && (
                    <div className={classes.loader}>
                        <CircularProgress color="primary" />
                    </div>
                )}
                {!isLoading && expenses.length > 0 && renderExpenseListGrid()}
                {!isLoading && expenses.length === 0 && (
                    <Grid2 paddingY={3}>
                        <Typography variant="body2">No results found</Typography>
                    </Grid2>
                )}
            </Grid2>
            {!isLoading && expenses.length > 0 && (
                <Box
                    ref={scrollbarRef}
                    sx={{
                        width: '100%',
                        overflowX: 'auto',
                        overflowY: 'hidden',
                        position: 'sticky',
                        bottom: 0,
                        left: 0,
                        zIndex: 10,
                        backgroundColor: 'white',
                        borderTop: '1px solid #e0e0e0',
                        paddingTop: '2px',
                        paddingBottom: '2px',
                        '&::-webkit-scrollbar': {
                            height: '10px',
                        },
                        '&::-webkit-scrollbar-track': {
                            backgroundColor: '#f1f1f1',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            backgroundColor: '#888',
                            borderRadius: '6px',
                        },
                        '&::-webkit-scrollbar-thumb:hover': {
                            backgroundColor: '#555',
                        },
                    }}
                >
                    <Box
                        sx={{
                            height: '1px',
                            width: scrollWidth,
                        }}
                    />
                </Box>
            )}
            {openCreditAlertModal && (
                <CreditDeterminationDialog
                    open={openCreditAlertModal}
                    onClose={() => setOpenCreditAlertModal(false)}
                    onConfirm={(creditType) => handleConfirmCreditModal(creditType)}
                    expense={expenseSelected}
                    isLoading={isCreatingCreditMemo}
                    error={creditMemoError}
                    payrollDayWarning={showPayrollWarningInCmm ? payrollWarningMessage : null}
                />
            )}
        </Box>
    );
};

export default withTranslation()(withStyles(styles)(ExpenseTable));
